import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } responsive={false} arrow={false} longArrow={true} >{ children ? children : '' }
            </Button>
}